import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Spinner,
  Stack,
  Text
} from "@chakra-ui/react";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Notification from "../../components/Common/Notification/index";
import { loginAdmin, Me } from "../../store/actions/admin/admin.action";

const Index = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isLoginRequestRunning, setIsLoginRequestRunning] = useState(false);

  const ErrorMessage = useSelector((state) => state.admin.errorMessage);

  const token = Cookies.get("token");

  let data = {
    identifier: username,
    password,
  };
  const handleSubmit = async () => {
    if (username === "" || password === "") {
      return Notification("", "कृपया आपली सांकेतिक माहिती  टाका", "error");
    }
    setIsLoginRequestRunning(true);
    if (!data) {
      alert("Please Enter Your Details");
      setIsLoginRequestRunning(false);
    }
    try {
      await dispatch(loginAdmin(data));
      await history.push("/");
      await window.location.reload();
      setIsLoading(false);
      setIsLoginRequestRunning(false);
    } catch (err) {
      setIsLoading(false);
      setIsLoginRequestRunning(false);
    }
  };

  useEffect(() => {
    if (token !== "" && token !== undefined) {
      dispatch(Me())
        .then(() => {
          history.push("/");
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);

          const errorMessage =
            (err?.response && err.response?.data?.message) ||
            "Something went wrong";
          return Notification("", errorMessage, "error");
        });
    }
  }, [token, history, dispatch]);
  if (isLoading) {
    <Flex>
      <Spinner />
    </Flex>;
  }
  return (
    <Flex h="100vh" w="100vw" align="center" justifyContent="center">
      <Flex
        minH="400px"
        w="500px"
        p={10}
        border="2px"
        borderRadius="10px"
        borderColor="cyan.500"
        direction="column"
      >
        <Heading fontSize="25px" fontWeight="bold" fontFamily="serif" mb={5}>
          कृपया आपली सांकेतिक माहिती टाका
        </Heading>

        <Stack spacing="9">
          <FormControl id="first-name" isRequired>
            {ErrorMessage !== "" ? (
              <Text
                color="red"
                fontWeight="bold"
                textAlign="start"
                pt={2}
                pb={2}
                fontSize="18px"
              >
                {ErrorMessage === "Identifier or password invalid."
                  ? "ओळखकर्ता किंवा संकेतशब्द अवैध"
                  : ErrorMessage}
              </Text>
            ) : null}
            <FormLabel fontWeight="bold" fontSize="20px">
              वापरकर्तानाव
            </FormLabel>
            <Input
              placeholder="वापरकर्तानाव"
              name="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </FormControl>
          <FormControl id="password" isRequired>
            <FormLabel fontWeight="bold" fontSize="20px">
              सांकेतिक शब्द{" "}
            </FormLabel>
            <Input
              type="password"
              placeholder="सांकेतिक शब्द "
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </FormControl>
          <Button
            type="submit"
            onClick={() => handleSubmit()}
            colorScheme="cyan"
            isLoading={isLoginRequestRunning}
            fontSize="20px"
          >
            प्रविष्ट करा
          </Button>
        </Stack>
      </Flex>
    </Flex>
  );
};

export default Index;
